import { addCompetior, deleteCompetior, queryCompetior, updateCompetior } from '@/request/competior';
export default {
    namespace: true,
    state: {
        competiorList: {}
    },
    mutations: {
        SET_COMPETIOR_LIST(state, competiorList) {
            state.competiorList = competiorList;
        }
    },
    actions: {
        QUERY_COMPETIOR: async ({ commit }, payload) => {
            let res = await queryCompetior(payload);
            if (res?.code == 200) {
                commit('SET_COMPETIOR_LIST', res.data ?? {});
            }
            return res;
        },

        ADD_COMPETIOR: async ({}, payload) => {
            let res = await addCompetior(payload);
            return res;
        },

        UPDATE_COMPETIOR: async ({}, payload) => {
            let res = await updateCompetior(payload);
            return res;
        },

        DELETE_COMPETIOR: async ({}, payload) => {
            let res = await deleteCompetior(payload);
            return res;
        }
    }
};
